import React from 'react';
const SvgOdtThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M26 29H6V3h15l5 5z" />
      <path fill="#949494" d="M21 2H5v28h22V8l-6-6zm0 1.5L25.5 8H21V3.5zM26 29H6V3h14v6h6v20z" />
      <path fill="#69AFE5" d="M15 11h9v1h-9z" />
      <path fill="#0078D7" d="M8 13h16v1H8z" />
      <path fill="#69AFE5" d="M15 9h3v1h-3z" />
      <path
        fill="#0078D7"
        d="M13.555 5.329l-.495 5.425c-.026.254-.039.42-.039.5a.5.5 0 00.32.5c.104.046.28.068.527.068l-.053.178h-2.569l.053-.178h.111a.887.887 0 00.51-.135.586.586 0 00.216-.303c.036-.099.07-.333.101-.702l.077-.827h-1.866l-.664.9a2.68 2.68 0 00-.283.434.622.622 0 00-.058.248c0 .103.042.191.125.265.083.074.221.114.414.12L9.929 12H8l.053-.178c.237-.01.446-.089.628-.238.18-.15.45-.467.81-.955l3.896-5.3h.168zm-.952 1.602l-1.89 2.573h1.64l.25-2.573z"
      />
      <path fill="#C8C8C8" d="M8 15h8v1H8zM8 17h8v1H8zM8 19h8v1H8zM8 21h16v1H8zM8 23h16v1H8zM8 25h16v1H8z" />
      <path fill="#69AFE5" d="M17 15h7v5h-7z" />
      <linearGradient
        id="odt-thumbnail_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={3.084}
        y1={3.607}
        x2={25.961}
        y2={30.872}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#odt-thumbnail_svg__a)" d="M27 8l-6-6H5v28h22V8z" />
      <linearGradient
        id="odt-thumbnail_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={20.148}
        y1={9.102}
        x2={24.114}
        y2={5.136}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#odt-thumbnail_svg__b)" d="M5 2v1h15v6h6v15.5h1V8l-6-6z" />
      <linearGradient id="odt-thumbnail_svg__c" gradientUnits="userSpaceOnUse" x1={23} y1={10.938} x2={23} y2={9.058}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#odt-thumbnail_svg__c)" d="M20 9h6v2h-6z" />
    </svg>
  );
});
export default SvgOdtThumbnail;
SvgOdtThumbnail.iconName = 'odt-thumbnail';
SvgOdtThumbnail.displayName = 'SvgOdtThumbnail';
